import React from "react";
import "./topUpModal.css";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row } from "react-bootstrap";
import moment from "moment";
import Select from "react-select";
import {
  getSellers,
  getSellersByCompanyId,
  getSellerWalletDetails,
  UpdateTopUpFundDetails,
} from "../../../store/actions/fundManagement";
import { GetAllLedgerCurrency } from "../../../store/actions/accounts.action";
import {
  GET_SELLERS,
  GET_WALLET_BALANCE,
} from "../../../store/types";
import DatePickerComponent from "../../common/DatePickerComponent";
import PropTypes from "prop-types";

function TopUpModal(props) {
  const {
    fundList,
    showModal = true,
    initialTopUpData,
    showConversionFields = false,
    onTopUpComplete,
    activeSellerList,
    filterData,
    onHide,
    lockCompanySeller = false,
    ...modalProps
  } = props;
  const modalRef = useRef();
  const hasAppliedInitialTopUpData = useRef(false);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [selectedsellerData, setselectedSellerData] = useState();
  const [amount, setAmount] = useState(null);
  const [sellerList, setSellerList] = useState([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const createdBy = useSelector((state) => state?.auth?.user);
  const sellerWalletBalance = useSelector(
    (state) => state?.FundManagementReducer?.getSellerWalletBalance?.EntityList
  );
  const getSellersValue = useSelector(
    (state) => state?.FundManagementReducer?.getSellersDetail?.EntityList
  );
  const { ledgerCurrencyList = [] } = useSelector((state) => state.accountingReducer || {});
  const [formData, setFormData] = useState({
    createdBy: createdBy?.Value?.employeeId,
    companyId: createdBy?.Value?.companyId,
    sellerId: createdBy?.Value?.sellerId,
    email: createdBy?.Value?.emailId,
    SellerName: {},
    isActive: true,
    id: selectedsellerData?.id,
    amount: 0,
    baseCurrencyId: 1,
    conversionRate: 1,
    baseConversionAmount: '',
    paymentModeId: '',
    transactionType: 6,
    topupCompanyId: null,
    shouldSendEmail: true
  });

  useEffect(() => {
    if (!initialTopUpData || hasAppliedInitialTopUpData.current) return;

    setFormData((prev) => ({
      ...prev,
      taskId: initialTopUpData.taskId || 0,
      topupCompanyId: initialTopUpData.topupCompanyId || null,
      topupSellerId: initialTopUpData.topupSellerId || null,
      amount: initialTopUpData.amount || 0,
      baseCurrencyId: initialTopUpData.baseCurrencyId || 1,
      conversionRate: initialTopUpData.conversionRate || 1,
      baseConversionAmount: initialTopUpData.baseConversionAmount || initialTopUpData.amount || '',
      paymentModeId: initialTopUpData.paymentModeId || '',
      ...(initialTopUpData.createdDate ? { createdDate: initialTopUpData.createdDate } : {}),
    }));
    hasAppliedInitialTopUpData.current = true;
  }, [initialTopUpData]);

  useEffect(() => {
    if (showConversionFields && !ledgerCurrencyList?.length) {
      dispatch(GetAllLedgerCurrency());
    }
  }, [dispatch, ledgerCurrencyList, showConversionFields]);

  useEffect(() => {
    setselectedSellerData('');
  }, [amount]);

  useEffect(() => {
    if (formData?.topupCompanyId?.value) {
      dispatch(getSellers(formData?.topupCompanyId?.Id));
      if (formData?.topupSellerId?.value) {
        dispatch(
          getSellerWalletDetails({
            topupCompanyId: formData?.topupCompanyId?.value,
            topupSellerId: formData?.topupSellerId?.value,
          })
        );
      }
    }
  }, [dispatch, formData]);

  const calculateWalletRechargeAmount = (baseConversionAmount, conversionRate, baseCurrencyId) => {
    const conversionAmountValue = Number(baseConversionAmount);
    const conversionRateValue = Number(conversionRate);
    if (!conversionAmountValue || !conversionRateValue) return '';

    return Number(baseCurrencyId) === 1
      ? conversionAmountValue.toString()
      : (conversionAmountValue / conversionRateValue).toFixed(2);
  };

  const renderConversionAmountDisplay = () => {
    const calculatedAmount = calculateWalletRechargeAmount(
      formData.baseConversionAmount,
      formData.conversionRate,
      formData.baseCurrencyId
    );
    if (!calculatedAmount) return null;

    return (
      <span className="mt-1 d-block">
        {formData.baseConversionAmount} / {formData.conversionRate} = $ {calculatedAmount}
      </span>
    );
  };

  const TopUpForm = (item, name, sellerDetail) => {
    if (name === "topupCompanyId") {
      // Invalidate stale sellers synchronously so the effect can't reuse the previous
      // company's sellers to repopulate the dropdown or auto-select a wrong seller.
      dispatch({ type: GET_SELLERS, payload: [] });
      setSellerList([]);
      setFormData({ ...formData, topupSellerId: null, [name]: item, availableAmount: null });
    } else if (showConversionFields && name === "baseCurrencyId") {
      const conversionRate = Number(item) === 1 ? 1 : '';
      setFormData({
        ...formData,
        baseCurrencyId: item,
        conversionRate,
        amount: calculateWalletRechargeAmount(formData.baseConversionAmount, conversionRate, item),
      });
    } else if (showConversionFields && name === "conversionRate") {
      setFormData({
        ...formData,
        conversionRate: item,
        amount: calculateWalletRechargeAmount(formData.baseConversionAmount, item, formData.baseCurrencyId),
      });
    } else if (showConversionFields && name === "baseConversionAmount") {
      setFormData({
        ...formData,
        baseConversionAmount: item,
        amount: calculateWalletRechargeAmount(item, formData.conversionRate, formData.baseCurrencyId),
      });
    } else {
      setFormData({ ...formData, [name]: item });
    }
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleDateChange = (e, name) => {
    const m = moment(e);
    setFormData({
      ...formData,
      [name]: m.isValid() ? m.format("MM-DD-YYYY") : "",
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  useEffect(() => {
    if (formData?.topupCompanyId?.value && getSellersValue?.length) {
      let data = getSellersValue.map((item) => {
        return {
          label: item.sellerName,
          value: item.sellerId,
        };
      });
      setSellerList(data);
      // Auto-select the lone seller when the selected company has exactly one
      if (data.length === 1) {
        setFormData(prev => (prev?.topupSellerId?.value ? prev : { ...prev, topupSellerId: data[0] }));
      }
    } else {
      setSellerList([]);
    }
  }, [getSellersValue, formData?.topupCompanyId?.value]);

  const handleCompanySellerDefault = useCallback(async () => {
    if (fundList?.length && activeSellerList.length) {
      let findChecked = fundList.filter(item => item.isChecked);
      if (findChecked.length) {
        getSellersByCompanyId(findChecked[0].companyId)?.then((resp) => {
          let data = resp?.data?.EntityList.map((item) => {
            return {
              label: item.sellerName,
              value: item.sellerId,
            };
          });
          setSellerList(data);
          let findInCompanyList = activeSellerList.filter(item => item.Id === findChecked[0].companyId)[0] || []; // NOSONAR
          let findInSellerList = data.filter(item => item.value === findChecked[0].sellerId)[0] || []; // NOSONAR
          setFormData((prev) => ({
            ...prev,
            topupCompanyId: findInCompanyList,
            topupSellerId: findInSellerList
          }))
        })
      }
    }
  }, [activeSellerList, fundList]);

  useEffect(() => {
    handleCompanySellerDefault();
  }, [handleCompanySellerDefault]);

  const handleTopUpComplete = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      topupSellerId: null,
      availableAmount: null,
    }));
    dispatch({
      type: GET_WALLET_BALANCE,
      payload: [],
    });
    dispatch({
      type: GET_SELLERS,
      payload: [],
    });
    onHide();
  };

  const buildTopUpPayload = () => {
    const pickedDate = moment(formData?.createdDate, ["MM-DD-YYYY", "MM-DD-YYYY HH:mm:ss", moment.ISO_8601], true);
    const now = moment();
    const createdDateMoment = pickedDate.isValid()
      ? pickedDate.set({
        hour: now.hour(),
        minute: now.minute(),
        second: now.second(),
        millisecond: now.millisecond(),
      })
      : now;
    const createdDateString = createdDateMoment.format("YYYY-MM-DDTHH:mm:ss.SSS");
    const topUpPayload = {
      ...formData,
      createdDate: createdDateString,
      topupCompanyId: formData?.topupCompanyId?.value,
      topupCompayId: formData?.topupCompanyId?.value,
      topupSellerId: formData?.topupSellerId?.value,
      role: createdBy?.Value?.role,
      companySellerId: createdBy?.Value?.companySellerId,
    };

    if (!showConversionFields) {
      delete topUpPayload.taskId;
      delete topUpPayload.baseCurrencyId;
      delete topUpPayload.conversionRate;
      delete topUpPayload.baseConversionAmount;
      delete topUpPayload.paymentModeId;
    }

    return topUpPayload;
  };

  const submitTopUp = async () => {
    setIsSaveDisabled(true);
    const success = await Promise.resolve(dispatch(UpdateTopUpFundDetails(
      buildTopUpPayload(),
      sellerWalletBalance,
      setAmount,
      createdBy?.Value?.isAdmin,
      handleTopUpComplete,
      filterData
    )
    ));
    if (!success) {
      setIsSaveDisabled(false);
    } else if (onTopUpComplete) {
      await onTopUpComplete();
    }
  };

  const getTopUpValidationErrors = () => {
    if (
      !formData?.topupCompanyId?.value &&
      !formData?.amount >= 0 &&
      !formData?.topupSellerId
    ) {
      return {
        SellerName: "This is a mandatory field",
        amount: "Amount should not be empty or 0",
        topupSellerId: "This is a mandatory field",
      };
    }
    if (!formData?.amount && !formData?.topupSellerId?.label) {
      return {
        amount: "Amount should not be empty or 0",
        topupSellerId: "This is a mandatory field",
      };
    }
    if (!formData?.amount) {
      return {
        amount: "Amount should not be empty or 0",
      };
    }
    if (showConversionFields && (!formData?.baseCurrencyId || !formData?.conversionRate || !formData?.baseConversionAmount)) {
      return {
        baseCurrencyId: !formData?.baseCurrencyId ? "This is a mandatory field" : "",
        conversionRate: !formData?.conversionRate ? "Conversion Rate is required" : "",
        baseConversionAmount: !formData?.baseConversionAmount ? "Conversion Amount is required" : "",
      };
    }
    if (!formData?.topupSellerId?.label) {
      return {
        topupSellerId: "This is a mandatory field",
      };
    }
    return null;
  };

  const saveTopUpData = async () => {
    if (
      formData?.topupCompanyId?.value &&
      formData?.amount > 0 &&
      formData?.topupSellerId
    ) {
      await submitTopUp();
    }
    const validationErrors = getTopUpValidationErrors();
    if (validationErrors) {
      setErrors(validationErrors);
    }
  };

  const handleCancel = () => {
    dispatch({
      type: GET_WALLET_BALANCE,
      payload: [],
    });
    dispatch({
      type: GET_SELLERS,
      payload: [],
    });
    onHide();
  };

  return (
    <Modal
      {...modalProps}
      size="lg"
      className="topUpModal"
      centered
      backdrop="static"
      ref={modalRef}
      show={showModal}
    >
      <div className="top_modal_header_container">
        <span className="">Top Up</span>
        <div className="modalDeleteWrapper">
          <button
            type="button"
            onClick={() => handleCancel()}
            className="btn-close"
            aria-label="Close"
          ></button>
        </div>
      </div>
      <div className="modal_container_rate_card">
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel ">
            <span className="input-label fnt-wgt-editmgmt">Company Name:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className={"select_react"}>
              <Select
                options={activeSellerList}
                onChange={(value) => TopUpForm(value, "topupCompanyId", "seller")}
                className="activeSellerListInput"
                value={formData.topupCompanyId}
                classNamePrefix="list-value"
                isDisabled={lockCompanySeller && Boolean(formData?.topupCompanyId?.value)}
              />
            </div>
            <p className="error dialogError"> {errors?.SellerName}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel ">
            <span className="input-label fnt-wgt-editmgmt">Seller Name:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className={"select_react"}>
              <Select
                options={sellerList}
                onChange={(value) => TopUpForm(value, "topupSellerId")}
                className="activeSellerListInput"
                isDisabled={!formData?.topupCompanyId?.name || (lockCompanySeller && Boolean(formData?.topupSellerId?.value))}
                value={formData?.topupSellerId}
                classNamePrefix="list-value"

              />
            </div>
            <p className="error dialogError">
              {" "}
              {errors?.topupSellerId}
            </p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Available Balance ($):</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <input
              onChange={(e) => TopUpForm(e, "AvailableBalance")}
              disabled
              value={
                sellerWalletBalance?.length &&
                sellerWalletBalance?.[0]?.availableAmount
              }
              className="form-control availableBalanceInput"
              type="text"
            />
            <p className="error dialogError">{errors.Name}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Transaction Date:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <DatePickerComponent
              data-testid={'createdDate'}
              className="form-control createdDate"
              dateFormat="MM-dd-yyyy"
              name="createdDate"
              onChange={(e) => handleDateChange(e, "createdDate")}
              selected={
                formData?.createdDate && moment(formData.createdDate, "MM-DD-YYYY", true).isValid()
                  ? moment(formData.createdDate, "MM-DD-YYYY").toDate()
                  : new Date()
              }
            />
            <p className="error dialogError">{errors.createdDate}</p>
          </div>
        </div>
        {showConversionFields && (
          <>
            <div className="row modal_input">
              <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
                <span className="input-label fnt-wgt-editmgmt">Currency:</span>
              </div>
              <div className="col-lg-8 col-sm-12">
                <select
                  className="form-control baseCurrencyId"
                  value={formData.baseCurrencyId || 1}
                  name="baseCurrencyId"
                  onChange={(e) => TopUpForm(e.target.value, "baseCurrencyId")}
                  disabled
                >
                  {ledgerCurrencyList?.map((currency) => (
                    <option key={currency.id} value={currency.id}>
                      {currency.currencyName}
                    </option>
                  ))}
                </select>
                <p className="error dialogError">{errors.baseCurrencyId}</p>
              </div>
            </div>
            <div className="row modal_input">
              <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
                <span className="input-label fnt-wgt-editmgmt">Conversion Rate:</span>
              </div>
              <div className="col-lg-8 col-sm-12">
                <input
                  onChange={(e) => TopUpForm(e.target.value, "conversionRate")}
                  className="form-control conversionRate"
                  min={1}
                  value={formData.conversionRate || ''}
                  disabled
                  onKeyDown={(event) => {
                    if (["e", "E", "+", "-"].includes(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  type="number"
                />
                <p className="error dialogError">{errors.conversionRate}</p>
              </div>
            </div>
            <div className="row modal_input">
              <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
                <span className="input-label fnt-wgt-editmgmt">Conversion Amount:</span>
              </div>
              <div className="col-lg-8 col-sm-12">
                <input
                  onChange={(e) => TopUpForm(e.target.value, "baseConversionAmount")}
                  className="form-control baseConversionAmount"
                  min={1}
                  value={formData.baseConversionAmount || ''}
                  readOnly
                  onKeyDown={(event) => {
                    if (["e", "E", "+", "-"].includes(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  type="number"
                />
                {renderConversionAmountDisplay()}
                <p className="error dialogError">{errors.baseConversionAmount}</p>
              </div>
            </div>
          </>
        )}
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Enter The Amount ($):</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <input
              onChange={(e) => TopUpForm(e.target.value, "amount")}
              className="form-control amountInput"
              min={1}
              value={formData.amount || ''}
              disabled={showConversionFields}
              onKeyDown={(event) => {
                if (event.key === "-") {
                  event.preventDefault(); // Prevents typing the minus sign
                }
              }}
              type="number"
            />
            <p className="error dialogError">{errors.amount}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Description:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <textarea
              maxLength={100}
              onChange={(e) => TopUpForm(e.target.value, "description")}
              className="form-control amountInput text-area"
              type="text"
              rows={3}
            />
          </div>
        </div>
        <div className="row modal_input fontFix">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel"></div>
          <div className="col-lg-8 col-sm-12">
            <input className="sendNotification" type="checkbox" checked={formData.shouldSendEmail} onChange={(e) => setFormData({ ...formData, shouldSendEmail: e.target.checked })} /> Send Notification Email
          </div>
        </div>
        <Row className="modaL_footer">
          <div
            className="col-12 noPadding"
            style={{ textAlign: "right" }}
            xs={12} // NOSONAR
          >
            <button
              className="btn cus-seconday-bg-btn"
              onClick={() => handleCancel()}
              disabled={isSaveDisabled}
            >
              Cancel
            </button>
            <button
              id="saveTopUpBtn"
              className="btn cus-seconday-bg-btn marginLeft5"
              disabled={isSaveDisabled}
              onClick={(e) => {
                saveTopUpData();
              }}
            >
              Add
            </button>
          </div>
        </Row>
      </div>
    </Modal>
  );
}

TopUpModal.propTypes = {
  fundList: PropTypes.array.isRequired,
  showModal: PropTypes.bool,
  showConversionFields: PropTypes.bool,
  lockCompanySeller: PropTypes.bool,
  onTopUpComplete: PropTypes.func,
  activeSellerList: PropTypes.array.isRequired,
  onHide: PropTypes.func.isRequired,
  filterData: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  initialTopUpData: PropTypes.shape({
    taskId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    topupCompanyId: PropTypes.object,
    topupSellerId: PropTypes.object,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    baseCurrencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    conversionRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    baseConversionAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paymentModeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    createdDate: PropTypes.string,
  })
};

export default TopUpModal;
